
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AIAnalyticsDashboard from './AIAnalyticsDashboard';
import AIInsightsDashboard from '@/components/analytics/AIInsightsDashboard';
import AdvancedPerformanceCharts from '@/components/analytics/AdvancedPerformanceCharts';
import PythonAnalyticsDashboard from '@/components/analytics/PythonAnalyticsDashboard';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Brain, BarChart3, TrendingUp, Code } from 'lucide-react';

const AnalyticsDashboard: React.FC = () => {

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5" />
            Advanced Analytics Dashboard
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Comprehensive AI-powered analytics and insights for learning management.
          </p>
        </CardContent>
      </Card>


      <Tabs defaultValue="system" className="space-y-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="system" className="flex items-center gap-2">
            <Brain className="h-4 w-4" />
            System Analytics
          </TabsTrigger>
          <TabsTrigger value="insights" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            AI Insights
          </TabsTrigger>
          <TabsTrigger value="performance" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Performance Charts
          </TabsTrigger>
          <TabsTrigger value="python" className="flex items-center gap-2">
            <Code className="h-4 w-4" />
            Python Analytics
          </TabsTrigger>
        </TabsList>

        <TabsContent value="system">
          <AIAnalyticsDashboard />
        </TabsContent>

        <TabsContent value="insights">
          <AIInsightsDashboard />
        </TabsContent>

        <TabsContent value="performance">
          <AdvancedPerformanceCharts />
        </TabsContent>

        <TabsContent value="python">
          <PythonAnalyticsDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AnalyticsDashboard;
